import { createContext } from 'react';

const APP_CONTEXT = createContext();
const AppContextProvider = APP_CONTEXT.Provider;

export { AppContextProvider, APP_CONTEXT };
